import { useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import FilesView from "../views/FilesView";

export default function FilesPage() {
  const ctx = useApp();
  const { folderId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const showStarred = location.pathname === "/app/files/starred";
  const showTrash = location.pathname === "/app/files/trash";
  const urlFolderId = folderId ? parseInt(folderId, 10) : null;

  useEffect(() => {
    ctx.setSelectedFiles([]);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    ctx.setActiveFolderId(urlFolderId);
  }, [folderId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (showTrash) ctx.fetchTrash();
  }, [showTrash]); // eslint-disable-line react-hooks/exhaustive-deps

  const goToAllFiles = () => navigate("/app/files");
  const goToStarred = () => navigate("/app/files/starred");
  const goToTrash = () => navigate("/app/files/trash");
  const goToFolder = (id) => navigate(`/app/files/folder/${id}`);

  return (
    <FilesView
      files={ctx.files} selectedFiles={ctx.selectedFiles} toggleSelectFile={ctx.toggleSelectFile}
      handleDelete={ctx.handleDelete} handleBulkDelete={ctx.handleBulkDelete}
      handleBulkDownload={ctx.handleBulkDownload} handleDownloadAll={ctx.handleDownloadAll}
      fileView={ctx.fileView} setFileView={ctx.setFileView}
      activeTagFilter={ctx.activeTagFilter} setActiveTagFilter={ctx.setActiveTagFilter}
      token={ctx.token} folders={ctx.folders} activeFolderId={ctx.activeFolderId}
      setActiveFolderId={ctx.setActiveFolderId} showNewCourseForm={ctx.showNewCourseForm}
      setShowNewCourseForm={ctx.setShowNewCourseForm} newCourseName={ctx.newCourseName}
      setNewCourseName={ctx.setNewCourseName} newCourseSubfolders={ctx.newCourseSubfolders}
      setNewCourseSubfolders={ctx.setNewCourseSubfolders} creatingCourse={ctx.creatingCourse}
      handleDeleteFolder={ctx.handleDeleteFolder} handleRenameFolder={ctx.handleRenameFolder}
      handleAssignFilesToFolder={ctx.handleAssignFilesToFolder}
      handleRemoveFileFromFolder={ctx.handleRemoveFileFromFolder}
      fetchFolderDefaults={ctx.fetchFolderDefaults} fetchFiles={ctx.fetchFiles}
      sortBy={ctx.sortBy} setSortBy={ctx.setSortBy} handleStarFile={ctx.handleStarFile}
      copiedFileId={ctx.copiedFileId} handleCopyFile={ctx.handleCopyFile}
      handlePasteFile={ctx.handlePasteFile} showUploadModal={ctx.showUploadModal}
      setShowUploadModal={ctx.setShowUploadModal} pendingFiles={ctx.pendingFiles}
      uploadTargetFolder={ctx.uploadTargetFolder} setUploadTargetFolder={ctx.setUploadTargetFolder}
      processUpload={ctx.processUpload} handleIncomingFiles={ctx.handleIncomingFiles} showNewFolderInModal={ctx.showNewFolderInModal}
      setShowNewFolderInModal={ctx.setShowNewFolderInModal} newFolderNameInModal={ctx.newFolderNameInModal}
      setNewFolderNameInModal={ctx.setNewFolderNameInModal} handleCreateCourse={ctx.handleCreateCourse}
      duplicateWarning={ctx.duplicateWarning} resolveDuplicate={ctx.resolveDuplicate}
      cancelDuplicateUpload={ctx.cancelDuplicateUpload}
      folderSuggestions={ctx.folderSuggestions} loadingSuggestions={ctx.loadingSuggestions}
      handleAcceptSuggestion={ctx.handleAcceptSuggestion} handleDismissSuggestion={ctx.handleDismissSuggestion}
      fetchFolderSuggestions={ctx.fetchFolderSuggestions} setFolderSuggestions={ctx.setFolderSuggestions}
      handleUpdateTag={ctx.handleUpdateTag}
      handleSummarizeAll={ctx.handleSummarizeAll} handleSummarizeFile={ctx.handleSummarizeFile}
      summarizingFileIds={ctx.summarizingFileIds} summarizingAll={ctx.summarizingAll}
      summarizeMessage={ctx.summarizeMessage} setSummarizeMessage={ctx.setSummarizeMessage}
      handleRetagAll={ctx.handleRetagAll} handleRetagFile={ctx.handleRetagFile}
      retaggingFileIds={ctx.retaggingFileIds} retaggingAll={ctx.retaggingAll}
      retagMessage={ctx.retagMessage} setRetagMessage={ctx.setRetagMessage} retagChanges={ctx.retagChanges} setRetagChanges={ctx.setRetagChanges}
      handleToggleTagLock={ctx.handleToggleTagLock}
      fetchRelatedFiles={ctx.fetchRelatedFiles} relatedFiles={ctx.relatedFiles}
      loadingRelated={ctx.loadingRelated} showRelatedPanel={ctx.showRelatedPanel}
      setShowRelatedPanel={ctx.setShowRelatedPanel}
      handleBackfillRelationships={ctx.handleBackfillRelationships}
      backfillingRelationships={ctx.backfillingRelationships} backfillMessage={ctx.backfillMessage}
      setBackfillMessage={ctx.setBackfillMessage}
      askQuestion={ctx.askQuestion} setAskQuestion={ctx.setAskQuestion}
      askAnswer={ctx.askAnswer} setAskAnswer={ctx.setAskAnswer}
      askLoading={ctx.askLoading} askError={ctx.askError} setAskError={ctx.setAskError}
      handleAskFiles={ctx.handleAskFiles}
      previewFile={ctx.previewFile} setPreviewFile={ctx.setPreviewFile}
      trashedFiles={ctx.trashedFiles} trashedFolders={ctx.trashedFolders}
      loadingTrash={ctx.loadingTrash} trashMessage={ctx.trashMessage} setTrashMessage={ctx.setTrashMessage}
      fetchTrash={ctx.fetchTrash} handleRestoreFile={ctx.handleRestoreFile}
      handlePermanentlyDeleteFile={ctx.handlePermanentlyDeleteFile}
      handleRestoreFolder={ctx.handleRestoreFolder} handlePermanentlyDeleteFolder={ctx.handlePermanentlyDeleteFolder}
      selectedTrashFiles={ctx.selectedTrashFiles} selectedTrashFolders={ctx.selectedTrashFolders}
      toggleSelectTrashFile={ctx.toggleSelectTrashFile} toggleSelectTrashFolder={ctx.toggleSelectTrashFolder}
      handleBulkRestoreFiles={ctx.handleBulkRestoreFiles} handleBulkPermanentDeleteFiles={ctx.handleBulkPermanentDeleteFiles}
      handleBulkRestoreFolders={ctx.handleBulkRestoreFolders} handleBulkPermanentDeleteFolders={ctx.handleBulkPermanentDeleteFolders}
      showStarred={showStarred} showTrash={showTrash}
      goToAllFiles={goToAllFiles} goToStarred={goToStarred} goToTrash={goToTrash} goToFolder={goToFolder}
      clipboard={ctx.clipboard} pasteCollision={ctx.pasteCollision} pasteFolderChoice={ctx.pasteFolderChoice}
      setPasteFolderChoice={ctx.setPasteFolderChoice}
      clipboardMessage={ctx.clipboardMessage} setClipboardMessage={ctx.setClipboardMessage}
      clipboardCopyFiles={ctx.clipboardCopyFiles} clipboardCutFiles={ctx.clipboardCutFiles}
      clipboardCopyFolder={ctx.clipboardCopyFolder} clipboardCutFolder={ctx.clipboardCutFolder}
      performFilePaste={ctx.performFilePaste} resolvePasteCollision={ctx.resolvePasteCollision}
      initiateFolderPaste={ctx.initiateFolderPaste} resolveFolderPasteChoice={ctx.resolveFolderPasteChoice}
      showGapAnalysisModal={ctx.showGapAnalysisModal} gapAnalysisStep={ctx.gapAnalysisStep}
      gapAnalysisFiles={ctx.gapAnalysisFiles} gapAnalysisSelectedIds={ctx.gapAnalysisSelectedIds}
      gapAnalysisCourseFolderName={ctx.gapAnalysisCourseFolderName} loadingGapAnalysisFiles={ctx.loadingGapAnalysisFiles}
      gapAnalysisSyllabusFiles={ctx.gapAnalysisSyllabusFiles} loadingSyllabusFiles={ctx.loadingSyllabusFiles}
      gapAnalysisSyllabusFileId={ctx.gapAnalysisSyllabusFileId} setGapAnalysisSyllabusFileId={ctx.setGapAnalysisSyllabusFileId}
      gapAnalysisResult={ctx.gapAnalysisResult}
      runningGapAnalysis={ctx.runningGapAnalysis} gapAnalysisError={ctx.gapAnalysisError} setGapAnalysisError={ctx.setGapAnalysisError}
      openGapAnalysisModal={ctx.openGapAnalysisModal} closeGapAnalysisModal={ctx.closeGapAnalysisModal}
      toggleGapAnalysisFile={ctx.toggleGapAnalysisFile}
      goToGapAnalysisStep2={ctx.goToGapAnalysisStep2} backToGapAnalysisStep1={ctx.backToGapAnalysisStep1}
      runGapAnalysis={ctx.runGapAnalysis}
    />
  );
}